export default __webpack_public_path__ + "static/media/SG5.41163629.webp";